import React, { useState } from 'react';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { string, bool, number } from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { getContext } from '@fiverr-private/fiverr_context';
import { s_flag_straight } from '@fiverr-private/icons';
import { workProcessStepsType } from '../propTypes';
import { FLAG_ICON_SIZE, FLAG_ICON_SIZE_MOBILE } from '../constants';
import MilestoneExpandedSteps from './MilestoneExpandedSteps';
import MilestoneCollapsedSteps from './MilestoneCollapsedSteps';
import MilestonePrice from './MilestonePrice';
import MilestoneHeader from './MilestoneHeader';

import './index.scss';

const WorkProcessItem = ({
    milestoneNumber,
    title,
    description,
    price: priceInUsd,
    duration, revisions,
    steps = [],
    selectedPackageId,
    defaultExpandedSteps = false
}) =>
{
    const { isMobile } = getContext();
    const [expandedSteps, setExpandedSteps] = useState(defaultExpandedSteps);
    const filteredSteps = steps.filter(({ packages = [] }) => packages.includes(selectedPackageId));
    const StepsElement = expandedSteps ? MilestoneExpandedSteps : MilestoneCollapsedSteps;
    const milestoneIconSize = isMobile ? FLAG_ICON_SIZE_MOBILE : FLAG_ICON_SIZE;

    const onStepsToggle = () => {
        setExpandedSteps((prevState) => !prevState);
    };

    return (
        <li className={classNames('work-process-milestone', { 'expanded': expandedSteps })}>
            <div className="milestone-icon-circle">
                <Icon className="flag-icon" size={milestoneIconSize}>{s_flag_straight}</Icon>
            </div>
            <section>
                <MilestoneHeader title={title}
                    duration={duration}
                    revisions={revisions}
                    expandedSteps={expandedSteps}
                    milestoneNumber={milestoneNumber}
                    price={isMobile ? (
                        <MilestonePrice priceInUsd={priceInUsd}
                            milestoneNumber={milestoneNumber}/>
                    ): null}
                    onStepsToggle={onStepsToggle}/>
                <p className="milestone-description">{description}</p>
                {!isEmpty(filteredSteps) && <StepsElement steps={filteredSteps}/>}
            </section>
            {!isMobile && (
                <MilestonePrice priceInUsd={priceInUsd}
                    milestoneNumber={milestoneNumber}/>
            )}
        </li>
    );
};

WorkProcessItem.propTypes = {
    milestoneNumber: number.isRequired,
    title: string.isRequired,
    description: string.isRequired,
    price: number.isRequired,
    duration: number.isRequired,
    revisions: number.isRequired,
    steps: workProcessStepsType,
    selectedPackageId: number.isRequired,
    defaultExpandedSteps: bool
};

export default WorkProcessItem;
